import { zodResolver } from "@mantine/form";
import { treatmentDataSchema } from "beitary-shared";
import { z } from "zod";

const adminTxFormSchema = treatmentDataSchema;

export type AdminTxFormValues = z.infer<typeof adminTxFormSchema>;

export const rules = zodResolver(adminTxFormSchema);
